module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"slogan":"Huntica - the first automated interview service with a real person","description":"Our online interview service reduces time spent on routine tasks and helps focus only on those that cannot be automated. As a result, recruitment time is reduced, human errors are minimized, and the cost of hiring is lowered."}}')
  delete Component.options._Ctor
}
